<template>
  <div class="page">
    <div class="page-con">
      <div class="title">模拟器操作声明</div>
      <div class="p-txt">
        尊敬的用户, 您好！欢迎您来到区域模拟器中心，参加术者培养模拟器体验项目。在您开始使用我们的设备进行练习之前，请您仔细阅读并理解以下内容，以确保您和我们的中心之间的
        <span class="col-txt">权利和责任明确</span>：
      </div>
      <div class="p-txt2">
        <div class="p-title">
          <img src="@/assets/images/simulator/img2.png" class="icon-img" alt="">
          <span class="txt2">安全责任</span>
        </div>
        <div class="tt-con">
          您理解并同意，在参加术者培养体验项目时，您将对自己的行为负责。因中心是租用第三方场所，请您使用时遵守中心管理规定及注意事项，保证自身及个人财产安全。如出现个人伤害、财产损失或其他不良后果，本中心无法承担责任。</div>
      </div>
      <div class="p-txt2">
        <div class="p-title">
          <img src="@/assets/images/simulator/img3.png" class="icon-img" alt="">
          <span class="txt2">设备使用</span>
        </div>
        <div class="tt-con">
          在使用手术操作模拟器设备时，请您务必按照中心的操作指南和专业人员的建议进行规范操作，如有问题，请及时与专业人员联系。您同意遵守设备的使用规范，并同意在使用过程中遵循相关安全和操作规定，如因人为过错或不当使用导致设备损坏，将承担相应责任。（如适用）
        </div>
      </div>
      <div class="p-txt2">
        <div class="p-title">
          <img src="@/assets/images/simulator/img4.png" class="icon-img" alt="">
          <span class="txt2">隐私声明</span>
        </div>
        <div class="tt-con">
          为协助您操作模拟器设备和根据您的模拟器操作记录帮助您提升手术技能，强生（上海）医疗器材有限公司（“我们”）需要收集和处理您的如下个人信息（姓名及所任职单位名称）及您的模拟器操作记录。我们承诺仅为操作模拟器的目的处理您提供的个人信息和模拟器操作记录。您签署本操作声明表示您同意我们收集和处理您的个人信息及您在模拟器上的操作记录。（如适用）
        </div>
      </div>
      <div class="p-txt2">
        <div class="tt-con tt-pdnone">请确保您已充分理解并同意上述声明的内容。
          本同意书在您签署后即刻生效，并在您持续参与模拟器中心练习和体验的期间长期有效。如果您对任何条款有疑问，请在签署之前与我们的工作人员联系。 感谢您的合作！</div>
      </div>
    </div>
    <div class="submit-btn" @click="handleSubmitRemind">同意</div>
    <div class="cancel-btn" @click="handleRemove">退出</div>
  </div>
</template>
<script>
import { postRemind } from '@/api/simulator'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  data () {
    return {
      imgSrc: ''
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
  },
  methods: {
    handleSubmitRemind () {
      postRemind(
        {
          'readType': 'SimulatorEmpower',
          'readTypeName': '模拟器授权阅读',
          'iepUserId': this.userInfo.id
        }
      ).then(res => {
        this.$router.replace({ path: '/simulator/poster', query: { simulatorId: this.$route.query.simulatorId } })
      })
    },
    handleRemove() {
      this.$router.replace({ path: '/home' })
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.page {
  background-color: #fff;
  min-height: 100vh;
  padding: 24px 20px;
  box-sizing: border-box;

  .page-con {
    position: relative;

    .title {
      font-size: 24px;
      font-weight: 600;
      color: #1A1A1A;
      margin-bottom: 16px;
    }

    .p-txt {
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      color: rgba(0, 0, 0, 0.8);
      line-height: 22px;

      .col-txt {
        color: #EB1700;
      }
    }

    .p-txt2 {
      margin-top: 16px;

      .p-title {
        display: flex;
        align-items: center;
        margin-bottom: 4px;

        .icon-img {
          width: 13px;
          display: block;
          margin-right: 7px;
        }

        .txt2 {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 21px;
        }
      }

      .tt-con {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-size: 14px;
        color: #7D7D7D;
        line-height: 21px;
        padding-left: 20px;
        box-sizing: border-box;

        &.tt-pdnone {
          padding-left: 0;
        }
      }
    }
  }

  .submit-btn {
    margin-top: 15px;
    width: 100%;
    height: 42px;
    border-radius: 100px;
    text-align: center;
    line-height: 42px;
    background: #EB1700;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 16px;
    color: #fff;
  }

  .cancel-btn {
    text-align: center;
    line-height: 42px;
    color: #7D7D7D;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/simulator/page.vue